import { GetAwsTagsProps } from './GetAwsTags.types';

export const getAwsTags = (props: GetAwsTagsProps): Record<string, string> => {
  const tags: Record<string, string> = {
    Environment: props.environment,
    Region: props.region,
    Product: props.product || 'job-runner',
    Department: 'platform services team',
    Purpose: 'job runner service',
    'map-migrated': 'migUJ1IX3DUXG',
  };

  if (props.tenant) {
    tags['cmp:tenant'] = props.tenant;
  }

  return tags;
};
